import {Component, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import {PopoverController} from "@ionic/angular";
import {DataService} from "../../../services/common/data.service";
import {PopoverSelectCarComponent} from "../popover-select-car/popover-select-car.component";


/**
 * Scelta veicolo riutilizzabile: card con avatar/nome/descrizione del veicolo
 * selezionato e pulsante "Seleziona/Cambia". Al click apre il popover di scelta
 * (tracker attivi e in flotta) ed emette il veicolo scelto via (carChange).
 *
 * Uso: <app-vehicle-select [car]="selCar" (carChange)="selectCar($event)"></app-vehicle-select>
 */
@Component({
  selector: 'app-vehicle-select',
  templateUrl: './vehicle-select.component.html',
  styleUrls: ['./vehicle-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleSelectComponent {

  /** Veicolo attualmente selezionato (Partecipant) o undefined. */
  @Input() car: any;

  /** Emesso quando l'utente sceglie un veicolo dal popover. */
  @Output() carChange = new EventEmitter<any>();

  constructor(
    private popoverCtrl: PopoverController,
    private data: DataService,
  ) {}

  /** Apre il popover di scelta veicolo ed emette il veicolo scelto. */
  async pick(event: any) {
    const cars: any[] = [];
    if (this.data.selOrganization && this.data.selOrganization.participants) {
      for (const participant of this.data.selOrganization.participants) {
        if (participant.isTracker() && participant.isActive && participant.isInFleet()) {
          cars.push(participant);
        }
      }
    }
    const popover = await this.popoverCtrl.create({
      component: PopoverSelectCarComponent,
      componentProps: {cars},
      cssClass: "popover_list",
      event: event,
    });
    popover.onDidDismiss().then((res: any) => {
      if (res && res.data && res.data.car) this.carChange.emit(res.data.car);
    });
    await popover.present();
  }
}
